'use client'

import { useSyncExternalStore } from 'react'

const DESKTOP_QUERY = '(min-width: 901px)'

function subscribeDesktop(onChange: () => void): () => void {
  const mq = window.matchMedia(DESKTOP_QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

function getDesktopSnapshot(): boolean {
  return window.matchMedia(DESKTOP_QUERY).matches
}

function getDesktopServerSnapshot(): boolean {
  return false
}

/** Matches the >900px breakpoint where the marketing grids stay two-column. */
export function useDesktopViewport(): boolean {
  return useSyncExternalStore(subscribeDesktop, getDesktopSnapshot, getDesktopServerSnapshot)
}
